import React, { useState, useEffect, useRef, createContext } from "react";
import { notificationAPI } from "../services/NotificationService";
import { baseURL } from "../utils/config";
import io from "socket.io-client"

export const AppContext = createContext({
  user: null,
  login: false,
  updateUser: () => { },
  updateLogin: () => { },
  socket: null,
  notifications: [],
  notifications_ref: 0,
  setNotifications: () => { },
  page: 1,
  setPage: () => { }
});

export const AppProvider = ({ children }) => {
  const token = localStorage.getItem("Token")
  const [user, setUser] = useState(null);
  const [login, setLogin] = useState(token ? true : false);
  const [notifications, setNotifications] = useState([])
  const [page, setPage] = useState(1)
  const notifications_ref = useRef(0)
  const socket = io.connect(baseURL, { query: { token }, transports: ['websocket'], autoConnect: true, reconnection: true, secure: true })

  function updateUser(params) {
    setUser(params)
  }

  function updateLogin(params) {
    setLogin(params)
  }

  useEffect(() => {
    if (user) {
      notificationAPI.getNotification(page)
        .then((res) => {
          if (res.status == 200) {
            if (Array.isArray(res.message)) {
              notifications_ref.current = res.message.length
              if (res.message.length >= 1) {
                let array = res.message.reduce((prev, curr) => {
                  let messageFind = notifications.find((res) => res._id == curr._id)
                  if (!messageFind) {
                    prev.push(curr)
                  }
                  return prev
                }, [])
                setNotifications((old) => [...old, ...array])
              }
            }
          }
        })
    }
  }, [user, page])

  return (
    <AppContext.Provider
      value={{
        user,
        login,
        socket,
        notifications_ref,
        notifications,
        setNotifications,
        page,
        setPage,
        updateUser,
        updateLogin
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
